var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgStarEmpty(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 30,
    viewBox: "0 0 32 30",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M14.5832 1.59894C15.0501 0.255601 16.9499 0.255602 17.4168 1.59894L19.7731 8.37746C20.1164 9.36513 21.0381 10.0348 22.0835 10.0561L29.2584 10.2023C30.6803 10.2313 31.2673 12.0381 30.134 12.8973L24.4154 17.2329C23.5822 17.8646 23.2301 18.9482 23.5329 19.949L25.611 26.8179C26.0228 28.1791 24.4858 29.2958 23.3185 28.4835L17.4279 24.3845C16.5697 23.7873 15.4303 23.7873 14.5721 24.3845L8.68152 28.4835C7.51416 29.2958 5.97719 28.1791 6.38902 26.8179L8.46712 19.949C8.76991 18.9482 8.41784 17.8646 7.58459 17.2329L1.86595 12.8973C0.732652 12.0381 1.31972 10.2313 2.74161 10.2023L9.91647 10.0561C10.9619 10.0348 11.8836 9.36514 12.2269 8.37746L14.5832 1.59894Z",
    fill: "#EDEEFB",
    stroke: "black"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgStarEmpty);
export default __webpack_public_path__ + "static/media/star_empty.7fd14a176560497024f220903fca1c3c.svg";
export { ForwardRef as ReactComponent };